import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
@Component({
  selector: 'multi-selector-tree-view',
  templateUrl: './multi-selector-tree-view.component.html',
  styleUrls: ['./multi-selector-tree-view.component.scss']
})
export class MultiSelectorTreeViewComponent implements OnInit {

  @Input() expandedKeys: any[];
  @Input() selectedId: number;
  @Input() isDisableParent: boolean = false;
  @Input() data: Array<any>;
  @Output() closeEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() onChange: EventEmitter<any> = new EventEmitter();
  @Input() displayName: string;
  @Input() enableAllNodes: boolean = false;
  @Input() searchKey: string = "name";
  @Input() public checkedKeys: any[] = [];

  ngOnChanges(changes: SimpleChanges) {
    this.checkDefaultValue(changes.checkedKeys.currentValue, this.data);
  }

  constructor(private cdRef: ChangeDetectorRef) { }

  public ngOnInit(): void {
    this.checkDefaultValue(this.checkedKeys, this.data);
    this.onChange.emit(this.checkedKeys);
    if(this.enableAllNodes){
      this.enableAll(this.data);
    }
  }

  ngAfterContentInit() {
    this.addExpandListItem(this.data);
  }

  ngAfterViewInit() {
    this.cdRef.detectChanges();
  }

  public checkDefaultValue(checkedKeys: number[], items: Array<any>) {
    for (var i = 0; i < items.length; i++) {
      if (checkedKeys.indexOf(items[i].id) > -1) {
        if (items[i].isSelectable) {
          items[i].isSelected = true;
          this.checkDefaultValue(checkedKeys, items[i].items);
        } else {
          items[i].isSelected = false;
        }
      }
      else {
        items[i].isSelected = false;
        this.checkDefaultValue(checkedKeys, items[i].items)
      }
    }
  }

  public handleCheck(dataItem: any) {
    dataItem.isSelected = !dataItem.isSelected;
    this.handleChildCheck(dataItem.items, dataItem.isSelected);
    this.checkedKeys = [];
    this.checkedKeys = this.getCheckedKeys(this.data, this.checkedKeys);
    this.onChange.emit(this.checkedKeys);
  }

  public handleChildCheck(childItems: Array<any>, isSelected: boolean) {
    for (var i = 0; i < childItems.length; i++) {
      if (childItems[i].isSelectable) {
        childItems[i].isSelected = isSelected;
        this.handleChildCheck(childItems[i].items, isSelected);
      }else{
        this.handleChildCheck(childItems[i].items, isSelected);
      }
    }
  }

  public enableAll(data: Array<any>){
    data.map(item=> {
      item.isSelectable = true;
      this.enableAll(item.items);
    })
  }

  public unCheckAll(items: Array<any>) {
    for (var i = 0; i < items.length; i++) {
      if (items[i].isSelectable) {
        items[i].isSelected = false;
        this.unCheckAll(items[i].items);
      }
    }
  }

  public getCheckedKeys(items: Array<any>, keys: number[]): number[] {
    for (var i = 0; i < items.length; i++) {
      if (items[i].isSelected) {
        keys.push(items[i].id);
      }
      keys = this.getCheckedKeys(items[i].items, keys);
    }
    return keys;
  }

  showClick(dataItem: any) {
    this.closeEvent.emit(dataItem);
  }

  private addExpandListItem(treeItem: Array<any>) {
    treeItem.forEach(item => {
      if (item.hasChild) {
        this.addExpandListItem(item.items)
      }
    });
  }

}
